import './App.css';
import React, { useState } from 'react';
import TennisGame from './TennisGame';
import FootballGame from './FootballGame';
import BasketballGame from './BasketballGame';
import ScoreBoard from './ScoreBoard';

function App() {
  const [activeGame, setActiveGame] = useState(null);
  const [showScoreBoard, setShowScoreBoard] = useState(false);
  const [scores, setScores] = useState([
    { game: 'football', teamA: 'Team 1', teamB: 'Team 2', scoreA: 0, scoreB: 0 },
    { game: 'basketball', teamA: 'Team 1', teamB: 'Team 2', scoreA: 0, scoreB: 0 },
    { game: 'tennis', teamA: 'Player 1', teamB: 'Player 2', scoreA: 0, scoreB: 0 }
  ]);

  const updateScore = (game, scoreA, scoreB) => {
    setScores(prevScores => prevScores.map(row =>
      row.game === game ? { ...row, scoreA, scoreB } : row
    ));
  };

  const handleGameClick = (game) => setActiveGame(game);
  const handleBack = () => setActiveGame(null);

  return (
    <div className="App">
      <header className="App-header">
        <div className="logo-container">
          <img src="https://cdn-icons-png.flaticon.com/512/1259/1259014.png" alt="Sports Logo" className="sports-logo" />
          <h1 className="title">SportZone</h1>
        </div>
        <nav className="nav-menu">
          <ul>
            <li><a href="#home" className="active">Home</a></li>
            <li><a href="#sports">Sports</a></li>
            <li><a href="#scores" onClick={() => setShowScoreBoard(true)}>Scores</a></li>
            <li><a href="#news">News</a></li>
          </ul>
        </nav>
      </header>
      <main className="main-content">
        {showScoreBoard && <ScoreBoard scores={scores} setScores={setScores} onBack={() => setShowScoreBoard(false)} />}
        {!showScoreBoard && activeGame === 'tennis' && <TennisGame score={scores.find(s => s.game === 'tennis')} updateScore={updateScore} onBack={handleBack} />}
        {!showScoreBoard && activeGame === 'football' && <FootballGame score={scores.find(s => s.game === 'football')} updateScore={updateScore} onBack={handleBack} />}
        {!showScoreBoard && activeGame === 'basketball' && <BasketballGame score={scores.find(s => s.game === 'basketball')} updateScore={updateScore} onBack={handleBack} />}
        {!showScoreBoard && !activeGame && (
        <section className="featured-sports">
          <h2>Featured Sports</h2>
          <div className="sports-grid">
            <div className="sport-card" onClick={() => handleGameClick('football')} style={{cursor: 'pointer'}}>
              <img src="https://cdn-icons-png.flaticon.com/512/1259/1259013.png" alt="Football" />
              <h3>Football</h3>
            </div>
            <div className="sport-card" onClick={() => handleGameClick('basketball')} style={{cursor: 'pointer'}}>
              <img src="https://cdn-icons-png.flaticon.com/512/1259/1259012.png" alt="Basketball" />
              <h3>Basketball</h3>
            </div>
            <div className="sport-card" onClick={() => handleGameClick('tennis')} style={{cursor: 'pointer'}}>
              <img src="https://cdn-icons-png.flaticon.com/512/1259/1259011.png" alt="Tennis" />
              <h3>Tennis</h3>
            </div>
          </div>
        </section>
        )}
      </main>
    </div>
  );
}

export default App;
